import { CuredApiPaths } from '../../models/enums';
import { UseMutationOptions } from '@tanstack/react-query';
import { PathWithID } from '../../models/types';
import { ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';

const useDeleteSegmentFolder = (folderId: string, mutateOptions?: UseMutationOptions<unknown, Error>) =>
    useMutation(
        MutationKeys.DELETE_SEGMENT_FOLDER,
        new PathWithID(CuredApiPaths.SEGMENT_FOLDERS, folderId),
        mutateOptions,
        ApiMethods.DELETE
    );

export default useDeleteSegmentFolder;
